import map from './parser-map';
import Outcome from './Outcome';
import helpers from '../helpers';

const betMap = map.sport.bet;

class Bet {
  constructor(rawObj) {
    this.id = rawObj[betMap.id];
    this.idSport = rawObj[betMap.idSport];
    this.name = rawObj[betMap.name];
    this.shortName = rawObj[betMap.shortName] || this.name;
    this.position = parseInt(rawObj[betMap.position], 10) || helpers.maxInt;
    this.grouping = rawObj[betMap.grouping];
    this.outcomes = rawObj[betMap.outcomes];
    this.type = rawObj[betMap.type];
    this.useMostBalanced = rawObj[betMap.useMostBalanced];
    this.parseOutcomes();
    this.active = true;
  }

  parseOutcomes() {
    if (this.outcomes) this.outcomes = _.map(this.outcomes, (value => new Outcome(value)));
  }
}

export default Bet;
